var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-toolbar',{staticClass:"app--toolbar"}),_c('app-left-drawer',{staticClass:"app-left-drawer"}),_c('app-content',{staticClass:"app--content"}),_c('app-fab'),_c('widget-fetch')],1)}
var staticRenderFns = []

export { render, staticRenderFns }